import { useEffect, useState } from "react";

const supported = typeof window !== "undefined" && "speechSynthesis" in window;

const chunk = (text) =>
  text.split(/\n+/).flatMap((l) => l.match(/[^.!?…]+[.!?…]*\s*/g) || []).map((s) => s.trim()).filter(Boolean);

export function useSpeech(text) {
  const [status, setStatus] = useState("idle");

  useEffect(() => () => supported && window.speechSynthesis.cancel(), []);

  const play = () => {
    const synth = window.speechSynthesis;
    if (status === "paused") { synth.resume(); setStatus("playing"); return; }
    synth.cancel();
    const voice = synth.getVoices().find((v) => v.lang?.toLowerCase().startsWith("fr"));
    const parts = chunk(text);
    parts.forEach((part, i) => {
      const u = new SpeechSynthesisUtterance(part);
      u.lang = "fr-FR";
      u.rate = 0.95;
      if (voice) u.voice = voice;
      if (i === parts.length - 1) u.onend = () => setStatus("idle");
      synth.speak(u);
    });
    setStatus("playing");
  };
  const pause = () => { window.speechSynthesis.pause(); setStatus("paused"); };
  const stop = () => { window.speechSynthesis.cancel(); setStatus("idle"); };

  return { supported, status, play, pause, stop };
}
